










import LogoWithFallback from "@/components/LogoWithFallback.vue";
import ProfileSelect from "@/components/ProfileSelect.vue";
import { User } from "@/models";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    ProfileSelect,
    LogoWithFallback,
  },
})
export default class UserProfile extends Vue {
  @Getter("user") readonly user!: User;
  @Getter("profile") readonly profile!: AdcontrolProfile;

  get logos(): string[] {
    if (this.user.profile?.isAgency) {
      return [this.profile?.accountCompany.iconUrl];
    }

    return this.user && this.user.profile?.company
      ? [this.user.profile.company.iconUrl]
      : [];
  }

  get company(): string | undefined {
    if (this.user.profile?.isAgency) {
      return this.profile?.accountCompany.name;
    }

    return this.user && this.user.profile?.company
      ? this.user.profile.company.name
      : undefined;
  }

  get username(): string | undefined {
    return this.user ? this.user.email : undefined;
  }
}
